// eslint-disable-next-line require-unicode-regexp -- ASCII-only regex
const nameRegex = /(?<prevChar>.)?(?<capitalChar>[A-Z])/gu;

export const convertPropertyName = (name: string): string =>
  name.replace(nameRegex, (_match: string, prevChar: string | undefined, capitalChar: string) =>
    prevChar ? `${prevChar}_${capitalChar.toLowerCase()}` : capitalChar.toLowerCase(),
  );

const renameKeys = (data: Record<string, unknown>, rename: (key: string) => string): Record<string, unknown> =>
  Object.fromEntries(Object.entries(data).map(([key, value]) => [rename(key), value]));

// Callers state the expected shape; the keys are only renamed, values are passed through as is.
export function formatDataToSubmit<T>(data: Record<string, unknown>): T {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- the shape is asserted by the caller
  return renameKeys(data, convertPropertyName) as T;
}

export const convertToCamelCase = (name: string): string =>
  // eslint-disable-next-line require-unicode-regexp -- ASCII-only regex
  name.replace(/_./gu, (chars) => chars.charAt(1).toUpperCase());

export function convertResponse<T>(data: Record<string, unknown>): T {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- the shape is asserted by the caller
  return renameKeys(data, convertToCamelCase) as T;
}
